import React, { useRef } from 'react';
import './ChatInput.css';

const ChatInput = ({ onSubmit, placeholder = "Type a message..." }) => {
  const textareaRef = useRef(null);

  // Auto-expand textarea height
  const handleInput = (e) => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    }
  };

  // Handle Enter/Shift+Enter
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      // Submit form
      e.target.form.requestSubmit();
      // Reset height after submit
      setTimeout(() => {
        if (textareaRef.current) textareaRef.current.style.height = '48px';
      }, 0);
    }
  };

  return (
    <form className="chat-input" onSubmit={onSubmit} autoComplete="off">
      <div className="input-container">
        <textarea
          ref={textareaRef}
          className="modern-textarea"
          name="messageInput"
          placeholder={placeholder}
          rows={1}
          onInput={handleInput}
          onKeyDown={handleKeyDown}
          style={{ minHeight: '48px', maxHeight: '180px' }}
        />
        <button type="submit" className="send-button">
          <img src="/sendButton.png" alt="Send" />
        </button>
      </div>
    </form>
  );
};

export default ChatInput; 